<template lang="pug">
  v-app
    SideBar
    ToolBar
    LogoutModal
    v-content
      v-container(fluid style="padding: 100px 30px 30px;" fill-height)
        v-card(min-height="100%", min-width="100%", elevation=4)
          router-view
</template>
<script>
import SideBar from './common/SideBar'
import ToolBar from './common/ToolBar'
export default {
  name: 'MainPage',
  components: {
    ToolBar,
    SideBar,
    LogoutModal: () => import('./common/LogoutModal'),
    Preloader: () => import('../common/Preloader/Preloader')
  },
  computed: {
    isPreloader() {
      return this.$store.state.reporting.isPreloader
    }
  }
}
</script>
<style lang="scss" scoped>
#app {
  background-color: #efeff4;
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage/index.vue